import React from "react";
import Heading from "../../elements/heading";
import PrimaryLink from "../../elements/primary-link";
import PropTypes from "prop-types";
import InfoBlock from "../../elements/info-block";

const InfoPanel = ({ infoHeadingType, infoHeadingBody, infoBody, infoCTA }) => {
  return (
    <InfoBlock>
      <Heading
        type={infoHeadingType}
        className="title show-on-scroll"
        html={infoHeadingBody}
        typographyClass="type-h3"
      />

      {infoBody && (
        <div
          className="body-text"
          dangerouslySetInnerHTML={{
            __html: infoBody.value
          }}
        />
      )}

      {infoCTA && <PrimaryLink {...infoCTA.fields} />}
    </InfoBlock>
  );
};

InfoPanel.propTypes = {
  infoHeadingType: PropTypes.object,
  infoHeadingBody: PropTypes.object,
  infoBody: PropTypes.shape({ value: PropTypes.string }),
  infoCTA: PropTypes.object
};

export default InfoPanel;
